import { Reveal, DrawnLine } from "./Reveal";
import { useLang } from "../i18n";

// Editorial section heading: chapter number, eyebrow, big thin title, copy.
// tone: "dark" (carbon bg) | "light" (ivory bg)
export const SectionHead = ({ chapter, eyebrow, title, copy, tone = "dark", align = "left" }) => {
  const { t } = useLang();
  const ink = tone === "dark" ? "text-[#F4F0E8]" : "text-[#171717]";
  const sub = tone === "dark" ? "text-[#F4F0E8]/60" : "text-[#171717]/65";
  const center = align === "center";
  return (
    <div className={center ? "text-center" : ""} data-testid="section-head">
      {(chapter || eyebrow) && (
        <Reveal>
          <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
            {chapter && (
              <span className="eyebrow text-[#C6A46A]">
                {String(chapter).padStart(2, "0")} <span className="opacity-50">/ {t.common.chapter}</span>
              </span>
            )}
            {eyebrow && <span className="eyebrow text-[#C6A46A]">{eyebrow}</span>}
            <DrawnLine className={center ? "hidden" : "max-w-24"} delay={0.2} />
          </div>
        </Reveal>
      )}
      {title && (
        <Reveal delay={0.08}>
          <h2 className={`mt-6 max-w-3xl text-2xl font-light leading-[1.15] tracking-tight sm:text-3xl lg:text-4xl ${ink} ${center ? "mx-auto" : ""}`}>
            {title}
          </h2>
        </Reveal>
      )}
      {copy && (
        <Reveal delay={0.16}>
          <p className={`mt-6 max-w-xl text-sm leading-relaxed sm:text-base ${sub} ${center ? "mx-auto" : ""}`}>{copy}</p>
        </Reveal>
      )}
    </div>
  );
};
